// extracted by mini-css-extract-plugin
export default {"table":"mirWbfikTi5FURFuDKtK","nameCell":"IyvGezmeNHA12710r4mJ","amountCell":"jaFieb9lyzSbiqypWLeA","rectangle":"r0idgMFFdP6o4AgUW5_d"};